export type NotificationPermissionExtended = NotificationPermission | 'unsupported';

export const getPermissionSettings = (): NotificationPermissionExtended => {
    if ('Notification' in window) {
        return Notification.permission;
    } else {
        return 'unsupported';
    }
};
